import React, { useState } from "react";
import StockItems from "./StockItems";
import StockRequests from "./StockRequests";

/**
 * Stock hub for admins: the catalogue (add, edit, adjust quantities) and the
 * queue of instructor requests against it (approve or reject). Tab switcher
 * mirrors Live Tracking's SwitchTabs.js.
 */
const SwitchStock = () => {
  const [step, setStep] = useState(1);

  function switchTab() {
    switch (step) {
      case 1:
        return <StockItems />;
      case 2:
        return <StockRequests />;
      default:
        return <StockItems />;
    }
  }

  return (
    <div className="p-8">
      <div className="flex gap-6 bg-white rounded-lg overflow-x">
        <div
          onClick={() => setStep(1)}
          className={`iskool-tab-item cursor-pointer p-4 ${
            step === 1
              ? "bg-gray-600 text-white shadow text-left "
              : "hover:bg-gray-100"
          }`}
        >
          <div className="text-lg">Stock Items</div>
        </div>
        <div
          onClick={() => setStep(2)}
          className={`iskool-tab-item cursor-pointer p-4 ${
            step === 2 ? "bg-gray-600 text-white shadow" : "hover:bg-gray-100"
          }`}
        >
          <div className="text-lg">Requests</div>
        </div>
      </div>

      <div>{switchTab()}</div>
    </div>
  );
};

export default SwitchStock;
